import { Editor } from 'slate';
import { isEjsPlaceholder } from '../helpers';
import { removeEjsNode } from '../transformers/modifyEjs';

// Custom plugin to facilitate EJS in Slate editor
export const withEjs = (editor: Editor): Editor => {
	const { isInline, deleteBackward, deleteForward, deleteFragment } = editor;

	// EJS placeholders are inline
	editor.isInline = (element) =>
		isEjsPlaceholder(element) || isInline(element);

	// Delete EJS elements as a whole
	editor.deleteBackward = (data) => {
		removeEjsNode(editor);
		deleteBackward(data);
	};
	editor.deleteForward = (data) => {
		removeEjsNode(editor);
		deleteForward(data);
	};
	editor.deleteFragment = (data) => {
		removeEjsNode(editor);
		deleteFragment(data);
	};

	return editor;
};
